import React from "react";
import {ButtonIconDelete, ButtonIconEdit} from "../../../../../Components/Inputs";
import {getTextByValue} from "../../../../../Utilities/Types/listUtilities";
import {BRAILLER_STATUS_LIST} from "../../braillerConstants";
import {getBraillerInventoryItemId, canDeleteInventoryItem} from "./braillerInventoryUtility";

interface BraillerInventoryRowProps {
    handleDeleteInventoryItem: (index: number) => void;
    handleEditInventoryItem: (index: number) => void;
    index: number;
    braillerInventoryItem: Record<string, any>;
}

export const BraillerInventoryRow = ({
                                         handleDeleteInventoryItem,
                                         handleEditInventoryItem,
                                         index,
                                         braillerInventoryItem,
                                     }: BraillerInventoryRowProps) => {

    const handleClickEditInventoryItem = () => {
        handleEditInventoryItem(index);
    };

    const handleClickDeleteInventoryItem = () => {
        handleDeleteInventoryItem(index);
    };

    const braillerInventoryItemId = getBraillerInventoryItemId(braillerInventoryItem, index);

    return (
        <tr id={braillerInventoryItemId} data-testid={braillerInventoryItemId}>
            <td>{braillerInventoryItem.serialNumber || ''}</td>
            <td>{getTextByValue(BRAILLER_STATUS_LIST, braillerInventoryItem.status)}</td>
            <td>{braillerInventoryItem.notes || ''}</td>
            <td>
                <ButtonIconEdit
                    inputDescription={`edit item ${index + 1}`}
                    onClick={() => handleClickEditInventoryItem()}
                />
                {
                    canDeleteInventoryItem(braillerInventoryItem) &&
                    <ButtonIconDelete
                        inputDescription={`delete item ${index + 1}`}
                        onClick={() => handleClickDeleteInventoryItem()}
                    />
                }
            </td>
        </tr>
    );
};
